(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookstan-product-edit"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-edit-direction]');if(!button)return;const track=document.getElementById(button.getAttribute('aria-controls'));if(!track)return;const direction=getComputedStyle(track).direction==='rtl'?-1:1;track.scrollBy({left:track.clientWidth*Number(button.dataset.editDirection)*direction,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookstan-product-story"] && !Shopify.designMode) return;
  try {
    
function setupLookstanDetails(root = document) {
  root.querySelectorAll('.ls-description h3').forEach(heading => {
    if (heading.closest('details')) return;
    const details = document.createElement('details');
    const summary = document.createElement('summary');
    const content = document.createElement('div');
    summary.textContent = heading.textContent;
    while (heading.nextSibling && !/^H[1-3]$/.test(heading.nextSibling.nodeName)) content.append(heading.nextSibling);
    details.append(summary, content);
    heading.replaceWith(details);
  });
}
setupLookstanDetails();
document.addEventListener('shopify:section:load', event => setupLookstanDetails(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookstan-video-edit"] && !Shopify.designMode) return;
  try {
    
function setupLookstanVideos(root=document){root.querySelectorAll('.ls-video-edit video').forEach(video=>{if(video.dataset.lsReady)return;video.dataset.lsReady='true';video.addEventListener('play',()=>{document.querySelectorAll('.ls-video-edit video').forEach(other=>{if(other!==video)other.pause();});});const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(!entry.isIntersecting)video.pause();});},{threshold:.1});observer.observe(video);});}
setupLookstanVideos();document.addEventListener('shopify:section:load',event=>setupLookstanVideos(event.target));document.addEventListener('visibilitychange',()=>{if(document.hidden)document.querySelectorAll('.ls-video-edit video').forEach(video=>video.pause());});
document.addEventListener('click',event=>{const button=event.target.closest('[data-video-direction]');if(!button)return;const track=button.closest('.ls-video-edit').querySelector('.ls-video-edit__track');track.scrollBy({left:track.clientWidth*Number(button.dataset.videoDirection)*(getComputedStyle(track).direction==='rtl'?-1:1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});

  } catch(e) { console.error(e); }
})();
})();
